import { currencyFormatter, percentageFormatter } from '@dnhb/formatters';
import RadioButton from '../../../../shared/RadioButton';
import { Flex } from '../../../../shared/layouts';
import ResultCard from './ResultCard';
import Collapse from './Collapse';

const MortgageResults = ({ results, currentFrt, setCurrentFrt, isLoading }) => {
  const frtResult = results?.frt_data || [];
  const frtOptions = frtResult.reduce(
    (total, { frt_years, nhg, without_nhg }) => {
      const lowestInterest = percentageFormatter(
        nhg?.interest_rate < without_nhg?.interest_rate
          ? nhg?.interest_rate
          : without_nhg?.interest_rate
      );
      const highestMax = currencyFormatter(
        nhg?.maximum_mortgage > without_nhg?.maximum_mortgage
          ? nhg?.maximum_mortgage
          : without_nhg?.maximum_mortgage,
        0
      );

      return [
        ...total,
        {
          value: frt_years,
          label: (
            <Flex justifyContent={'space-between'}>
              <span>{`${frt_years} jaar rentevast ${lowestInterest}`}</span>
              <b>{highestMax}</b>
            </Flex>
          )
        }
      ];
    },
    []
  );
  const currentResult = frtResult.find(frt => frt?.frt_years === currentFrt);

  return (
    <>
      <Flex
        justifyContent={'space-between'}
        flexDirection={{ mobile: 'column', tablet: 'row' }}
        css={({ space }) => ({ gap: space.m })}
      >
        {currentResult?.nhg && (
          <ResultCard isLoading={isLoading} {...currentResult?.nhg} />
        )}
        {currentResult?.without_nhg && (
          <ResultCard isLoading={isLoading} {...currentResult?.without_nhg} />
        )}
      </Flex>
      <Collapse title={'Toon andere rentevast periode'}>
        <RadioButton
          name={'frt'}
          value={currentFrt}
          onChange={value => setCurrentFrt(parseInt(value, 10))}
          options={frtOptions}
        />
      </Collapse>
    </>
  );
};

export default MortgageResults;
